import api from "./api";
const endpoint = "WebsiteRestController";

export const AssociationService = {
  async getAllAssociation(filtre) {
    try {
      const result = await api.get(endpoint + "/list_association", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAllAssociationCandidate(filtre) {
    try {
      const result = await api.get(endpoint + "/list_tous_association", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAllSelectedAssociation(filtre) {
    try {
      const result = await api.get(endpoint + "/list_selected_association", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteSeletedAssociation(id_asso) {
    try {
      const result = await api.post(endpoint + "/delete_selected_association", {
        id_asso: id_asso,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(uuid) {
    try {
      const result = await api.get(endpoint + "/find_association", {
        params: { uuid: uuid },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async postuler(id_offre) {
    try {
      const result = await api.post(endpoint + "/offre_emploi_list", id_offre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async showMembres(uuid) {
    try {
      const result = await api.get(endpoint + "/liste_membre", {
        params: { uuid: uuid },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(association) {
    try {
      const result = await api.post(
        endpoint + "/insert_association",
        association,
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteAssociation(association) {
    try {
      const result = await api.post(
        endpoint + "/delete_association",
        association,
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async addMembre(membre) {
    try {
      const result = await api.post(endpoint + "/add_membre", membre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async addMembreInsertedByODKForm() {
    try {
      const result = await api.get(
        endpoint + "/insertMembreAssociationByODKForm",
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async fetchMembreInsertedByODKForm(form_id) {
    try {
      const result = await api.get(endpoint + "/fetch_odk_data_submission", {
        params: { form_id: form_id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateMembre(membre) {
    try {
      const result = await api.post(endpoint + "/update_membre", membre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteMembre(id_membre, id_association) {
    try {
      const result = await api.post(endpoint + "/delete_membre", {
        id_ext_responsable_association: id_membre,
        asso_uuid: id_association,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneMembre(id) {
    try {
      const result = await api.get(endpoint + "/find_one_membre", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(association) {
    try {
      const result = await api.post(
        endpoint + "/update_association",
        association,
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      console.log("err update:", error);

      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAssociationInfo(uuid) {
    try {
      const result = await api.get(endpoint + "/find_association", {
        params: { uuid: uuid },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      console.log("errrrrr");

      if (error.response) {
        return error.response.data;
      }
    }
  },
  async create(data) {
    throw new Error("Method not implemented.");
  },
  async softDelete(data) {
    throw new Error("Method not implemented.");
  },
  async hardDelete(data) {
    throw new Error("Method not implemented.");
  },
  async restore(data) {
    throw new Error("Method not implemented.");
  },
  async list(data) {
    throw new Error("Method not implemented.");
  },
};
